import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Select } from 'semantic-ui-react'
import classnames from 'classnames/bind'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

class YearMonthForm extends Component {
  static propTypes = {
    elmId: PropTypes.string.isRequired,
    date: PropTypes.instanceOf(Date).isRequired,
    localeUtils: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
  }

  handleChange = (e, data) => {
    const { date } = this.props
    const { name, value } = data
    if (name === 'month') {
      this.props.onChange(new Date(date.getFullYear(), value))
    } else {
      this.props.onChange(new Date(value, date.getMonth()))
    }
  }

  get monthOptions() {
    const { localeUtils, elmId } = this.props
    const months = localeUtils.getMonths().map((month, i) => ({
      key: month,
      text: month,
      value: i,
      'data-elm-id': `${elmId}_month_${month}`,
    }))
    return months
  }

  get yearOptions() {
    const { elmId } = this.props
    const currentYear = new Date().getFullYear()
    const fromYear = new Date(currentYear - 100, 0).getFullYear()
    const toYear = new Date(currentYear, 11).getFullYear()
    const years = []
    for (let i = fromYear; i <= toYear; i++) {
      years.push({
        key: i,
        text: i,
        value: i,
        'data-elm-id': `${elmId}_year_${i}`,
      })
    }
    return years
  }

  render() {
    const { date, elmId } = this.props

    return (
      <div
        className={cx('datepicker-caption')}
        data-elm-id={`${elmId}_datepicker_caption`}
      >
        <Select
          name='month'
          className={cx('datepicker-month')}
          data-elm-id={`${elmId}_month_select_box`}
          onChange={this.handleChange}
          options={this.monthOptions}
          value={date.getMonth()}
        />
        <Select
          name='year'
          className={cx('datepicker-year')}
          data-elm-id={`${elmId}_year_select_box`}
          onChange={this.handleChange}
          options={this.yearOptions}
          value={date.getFullYear()}
        />
      </div>
    )
  }
}

export default YearMonthForm
